import React from 'react';
import OpenPlayToolsLayout from '../../components/openplay/OpenPlayToolsLayout';
import Icon from '../../components/openplay/OpenPlayIcon';

const OpenPlayNotificationsPage = () => {
  return (
    <OpenPlayToolsLayout userRole="player">
      <main className="pt-6 md:pt-10">
        <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="mb-6 md:mb-8">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-2">알림</h1>
            <p className="text-base md:text-lg caption text-muted-foreground">커밍순 · 서비스 예정</p>
          </div>

          <div className="bg-card border border-border rounded-xl p-8 md:p-10 flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
              <Icon name="BellIcon" size={34} className="text-primary" />
            </div>
            <p className="mt-5 text-xl md:text-2xl font-heading font-semibold text-foreground">알림 기능 준비 중</p>
            <p className="mt-2 text-sm md:text-base caption text-muted-foreground whitespace-pre-line">
              카카오톡 연동 및 알림 설정 기능은 현재 준비 중입니다.
              업데이트로 곧 제공할 예정입니다.
            </p>
          </div>
        </div>
      </main>
    </OpenPlayToolsLayout>
  );
};

export default OpenPlayNotificationsPage;
